import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/configuracao-sistema`

    return {
        show() {
            return repository.get(`${baseUrl}`)
        },
        edit() {
            return repository.get(`${baseUrl}/edit`)
        },
        update(params) {
            return repository.patch(`${baseUrl}`, params)
        },
    }
}